import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Typography from '@hellodarwin/core/lib/components/common/typography';
import { useTheme } from 'styled-components';
import { StatisticsContentStyled } from '../styles';
const StatisticsContent = ({ number, overline, body }) => {
    const theme = useTheme();
    const statisticsProps = {
        cap: 180,
        number: number,
        overline: overline,
        body: body,
        color: theme.colors.white_1,
    };
    return (_jsxs(StatisticsContentStyled, { children: [!!number && (_jsx(Typography.Title, { level: 3, elementTheme: "h2", color: statisticsProps.color, textTransform: "uppercase", fitContent: true, noMargin: true, style: { marginLeft: 0 }, tablet: { elementTheme: 'h2' }, children: number })), !!(overline === null || overline === void 0 ? void 0 : overline.length) && (_jsx(Typography.Title, { level: 4, elementTheme: "h3", color: statisticsProps.color, children: overline })), !!(body === null || body === void 0 ? void 0 : body.length) && (_jsx(Typography, { color: statisticsProps.color, elementTheme: "subtitle1", style: { minHeight: 56 }, children: body }))] }));
};
export default StatisticsContent;
